/// <amd-module name="Repos/Views/PullRequest/RestClient/Notification" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\pr-details\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Notification from "Notifications/Common/Contracts/Notification";

export interface INotificationRestClient extends IVssRestClient {
    /**
     * Query for subscriptions. A subscription is returned if it matches one or more of the specified conditions.
     * 
     * @param subscriptionQuery - 
     */
    querySubscriptions(subscriptionQuery: Notification.SubscriptionQuery): Promise<Notification.NotificationSubscription[]>;
    /**
     * Create a new subscription.
     * 
     * @param createParameters - 
     */
    createSubscription(createParameters: Notification.NotificationSubscriptionCreateParameters): Promise<Notification.NotificationSubscription>;
    /**
     * Delete a subscription.
     * 
     * @param subscriptionId - 
     */
    deleteSubscription(subscriptionId: string): Promise<void>;
}

class NotificationRestClient extends RestClientBase implements INotificationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Query for subscriptions. A subscription is returned if it matches one or more of the specified conditions.
     * 
     * @param subscriptionQuery - 
     */
    public async querySubscriptions(
        subscriptionQuery: Notification.SubscriptionQuery
        ): Promise<Notification.NotificationSubscription[]> {

        return this.beginRequest<Notification.NotificationSubscription[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/notification/SubscriptionQuery",
            body: subscriptionQuery
        });
    }

    /**
     * Create a new subscription.
     * 
     * @param createParameters - 
     */
    public async createSubscription(
        createParameters: Notification.NotificationSubscriptionCreateParameters
        ): Promise<Notification.NotificationSubscription> {

        return this.beginRequest<Notification.NotificationSubscription>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/notification/Subscriptions/{subscriptionId}",
            body: createParameters
        });
    }

    /**
     * Delete a subscription.
     * 
     * @param subscriptionId - 
     */
    public async deleteSubscription(
        subscriptionId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/notification/Subscriptions/{subscriptionId}",
            routeValues: {
                subscriptionId: subscriptionId
            }
        });
    }

}

export const NotificationClientName = "Repos.PRDetails.Notification.INotificationRestClient";

export function getNotificationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): INotificationRestClient {
    return pageContext.getRestClient<INotificationRestClient>(NotificationClientName, options);
}

RestClients.add(NotificationClientName, { 
    factory: NotificationRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
